import back_arrow from "../assets/backarrow.svg";
import collapse from "../assets/collapse.svg"
import expand from "../assets/expand-teams.svg"
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import feedback_api from "../api/protected/feedback";


const FeedbackReviews = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [teamId, setTeamId] = useState("");
    const [data, setData] = useState({"q4_responses": [],"q5_responses": [],"q6_responses": []})
    const [showQuestion4, setShowQuestion4] = useState(false)
    const [showQuestion5, setShowQuestion5] = useState(false)
    const [showQuestion6, setShowQuestion6] = useState(false)

    const getFeedbackReviews = () => {
        if (!teamId) return;
        let response = feedback_api.getFeedbackReviews(teamId)
        response.then(response => {
            setData(response.data)
        })
    }

    const BackButton = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate(`/teams/${teamId}`)
        }
    }

    useEffect(() => {
        getFeedbackReviews()
    }, [teamId])

    useEffect(() => {
        if (!params.teamId) return;
        setTeamId(params.teamId)
    }, [params.teamId]);

    return(
        <div className="feedback-page-background-container">
            <div className="feedback-page-container">
                <div className="summary-title-container">
                    <div className="summary-back-button link" onClick={BackButton}>
                        <img className={"back-arrow-classname"} src={back_arrow} alt="Back Arrow"/>
                    </div>
                    <div className="summary-title">All Feedback Reviews</div>
                </div>
                <div className="edit-team-latest-survey-divider"/>
                <div className="feedback-review-container">
                    <div className="feedback-review-section-container">
                        <div className={`feedback-review-section-title-container ${showQuestion4 ? "collapsed":""}`}>
                            <div className="feedback-review-section-title">
                                What would have made the team coaching experience more valuable for you?
                            </div>
                            <img src={showQuestion4 ? collapse : expand}
                                 className={`link`}
                                 onClick={() => setShowQuestion4(!showQuestion4)} alt={"expand button"}/>
                        </div>
                        {showQuestion4 ?
                            <div className="feedback-review-section-comments-container">
                                {data.q4_responses && data.q4_responses.map((comment, idx) => {
                                    return(
                                        <div className="feedback-review-comment-container" key={idx}>{comment}</div>
                                    )
                                })}
                            </div>
                            :null}
                    </div>
                    <div className="feedback-review-section-container">
                        <div className={`feedback-review-section-title-container ${showQuestion5 ? "collapsed":""}`}>
                            <div className="feedback-review-section-title">
                                What was the most confusing or challenging part of the team coaching experience?
                            </div>
                            <img src={showQuestion5 ? collapse : expand}
                                 className={`link`}
                                 onClick={() => setShowQuestion5(!showQuestion5)} alt={"expand button"}/>
                        </div>
                        {showQuestion5 ?
                            <div className="feedback-review-section-comments-container">
                                {data.q5_responses && data.q5_responses.map((comment, idx) => {
                                    return(
                                        <div className="feedback-review-comment-container" key={idx}>{comment}</div>
                                    )
                                })}
                            </div>
                            :null}
                    </div>
                    <div className="feedback-review-section-container">
                        <div className={`feedback-review-section-title-container ${showQuestion6 ? "collapsed":""}`}>
                            <div className="feedback-review-section-title">
                                Is there anything else you think we should know?
                            </div>
                            <img src={showQuestion6 ? collapse : expand}
                                 className={`link`}
                                 onClick={() => setShowQuestion6(!showQuestion6)} alt={"expand button"}/>
                        </div>
                        {showQuestion6 ?
                            <div className="feedback-review-section-comments-container">
                                {data.q6_responses && data.q6_responses.map((comment, idx) => {
                                    return(
                                        <div className="feedback-review-comment-container" key={idx}>{comment}</div>
                                    )
                                })}
                            </div>
                            :null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeedbackReviews